// extracted by mini-css-extract-plugin
export default {"Chip":"StatusChip_Chip__ehqse","BgName":"StatusChip_BgName__Cp6QB","Label":"StatusChip_Label__+5OAX","Compact":"StatusChip_Compact__AyamT"};